'use client'

import * as SwitchPrimitive from '@radix-ui/react-switch'
import * as React from 'react'

import { cn } from '../../utils/cn'

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    // Track colour keys off the thumb's data-state via :has(), not the root's own
    // data-state: when the Switch is an `asChild` trigger child (e.g. a Tooltip), the
    // trigger overwrites the root's data-state, but never the thumb's (Radix drives it
    // from context) — so the track stays correct regardless of how it's composed.
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'has-[[data-state=checked]]:bg-primary has-[[data-state=unchecked]]:bg-input hover:has-[[data-state=unchecked]]:bg-input/80 focus-visible:border-ring focus-visible:ring-ring peer inline-flex h-[20px] w-8 shrink-0 cursor-pointer items-center rounded-full border border-transparent p-[3px] shadow-xs transition-all outline-none focus-visible:ring-[2px] disabled:cursor-not-allowed disabled:opacity-50 hover:has-[[data-state=checked]]:brightness-105',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'bg-primary data-[state=checked]:bg-primary-foreground dark:data-[state=unchecked]:bg-primary dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-3.5 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-3px)] data-[state=unchecked]:translate-x-0'
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
